/**
 * @author Damian Kajzer <damian.kajzer@sowlgroup.com>
 * Falcon complaint decision type dictionary
 */
export enum FalconComplaintDecisionType {
  None = 0,
  Positive,
  Negative
}
